// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1Qk47","selects":"Documents_selects__2N_5L"};